// extracted by mini-css-extract-plugin
export var truncate = "_i-0";